import { Component, inject } from '@angular/core';
import { LanguageSelectorComponent } from 'src/app/ui/molecules/language-selector/language-selector.component';
import { TestDataService } from 'src/app/services/testData.service';
import { logger } from 'src/app/utils';

@Component({
    selector: 'app-test-data',
    imports: [
        LanguageSelectorComponent
    ],
    templateUrl: './test-data.component.html',
    styleUrl: './test-data.component.scss'
})
export class TestDataComponent {
  public testDataService = inject(TestDataService);

  setTypeRentalPoints(event: any) {
    this.testDataService.sameRentalPoint = event?.target.value;
  }

  public cards = new Map<number, string>([
    [0, '4012001037461114'],
    [1, '4200000000000000'],
    [2, '4200000000000091'],
    [3, '4200000000000042']
  ]);

  cardNumber: any;

  setCardType(event: any) {
    const cardType = Number(event?.target.value);
    this.cardNumber = this.cards.get(cardType) || this.cards.get(1);
  }

  copyCardClipboard() {
    navigator.clipboard.writeText(this.cardNumber).then(() => {
      logger.i('Card number copied to clipboard');
    }).catch(err => {
      logger.w('Failed to copy card number: ', err);
    });
  }

}
